import script from "./MainMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainMenu.vue?vue&type=script&lang=ts&setup=true"

import "./MainMenu.vue?vue&type=style&index=0&id=7384e770&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7384e770"]])

export default __exports__